module.exports = "pegasus/assets/header-default-1.jpg";